"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataController = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
const toolbox_1 = require("@streem/toolbox");
const pako_1 = require("pako");
class DataController {
    constructor(localSource, remoteSource, localUserId) {
        this.messagesSubject = new rxjs_1.Subject();
        this.unsubscribe = new rxjs_1.Subject();
        this.incrementLogOfTracksSent = new rxjs_1.Subject();
        this.packetAccumulators = {};
        this.messages = this.messagesSubject.asObservable();
        const remoteSourceMessages = remoteSource.pipe((0, operators_1.mergeMap)(track => (!track ? rxjs_1.EMPTY : track.messages)));
        // Log how many data track messages are sent every 5 seconds
        this.bufferCountDataTrackMessages(this.incrementLogOfTracksSent.asObservable()).subscribe(count => {
            if (count > 0) {
                logger_1.logger.info(`${localUserId} has sent ${count} DataTrackMessages in the past 5 seconds`);
            }
        });
        // Log how many data track messages are received every 5 seconds
        this.bufferCountDataTrackMessages(remoteSourceMessages).subscribe(count => {
            if (count > 0) {
                logger_1.logger.info(`${localUserId} has received ${count} DataTrackMessages in the past 5 seconds`);
            }
        });
        // Set the local track
        localSource.pipe((0, operators_1.takeUntil)(this.unsubscribe)).subscribe(track => (this.localTrack = track));
        // Handle remote data track messages
        remoteSourceMessages
            .pipe((0, operators_1.takeUntil)(this.unsubscribe))
            .subscribe((msg) => {
            if (msg.type !== 'dataTrackPacket') {
                this.messagesSubject.next(msg);
            }
            else {
                this.handleDataTrackPacket(msg);
            }
        });
    }
    disconnect() {
        this.unsubscribe.next(undefined);
    }
    send(message) {
        if (!this.localTrack) {
            logger_1.logger.warn('Unable to send data track message, no local track exists');
            return;
        }
        this.localTrack.send(message);
        this.incrementLogOfTracksSent.next(undefined);
    }
    bufferCountDataTrackMessages(source) {
        return source.pipe((0, operators_1.bufferTime)(5000), (0, operators_1.map)(m => m.length), (0, operators_1.takeUntil)(this.unsubscribe));
    }
    handleDataTrackPacket(msg) {
        // if I receive a data chunk, I need to accumulate it somewhere and return early
        // if I receive a data chunk and it's the last chunk needed to construct a message, emit it with this.messagesSubject.next(msg)
        (0, toolbox_1.invariant)(msg.dataTrackPacket, 'The DataTrackMessage must be a dataTrackPacket');
        const packet = msg.dataTrackPacket;
        (0, toolbox_1.invariant)(packet.type, 'The type of DataTrackMessage must be defined');
        const accumulatorKey = packet.type;
        //* * If this is the first packet out of many packets and it's not on our accumulators, create it. */
        let accumulator = this.packetAccumulators[accumulatorKey];
        if (packet.index === 1) {
            if (accumulator !== undefined) {
                logger_1.logger.warn(`Incomplete receipt of DataTrackMessage: ${packet.type} messageId: ${accumulator.id} - recieved ${accumulator.latestIndex} packets. Now recieving packet #${packet.index} of messageId ${packet.messageId}.`);
            }
            accumulator = this.packetAccumulators[accumulatorKey] = {
                id: packet.messageId,
                latestIndex: 0,
                data: [],
            };
        }
        if (accumulator === undefined) {
            logger_1.logger.warn(`Incomplete receipt of DataTrackMessage: ${packet.type}  - no accumulator found. Now recieving packet #${packet.index} of messageId ${packet.messageId}.`);
            return;
        }
        // If the message is of the same type && we received the next packet...
        if (accumulator.id === packet.messageId && accumulator.latestIndex + 1 === packet.index) {
            accumulator.latestIndex = packet.index;
            if (packet.data) {
                accumulator.data.push(...packet.data);
            }
            // If this is the last packet...
            if (packet.index === packet.numberOfPackets) {
                let data = new Uint8Array(accumulator.data);
                if (packet.compression === streem_sdk_protobuf_1.streem.room.DataTrackPacket.Compression.COMPRESSION_GZIP) {
                    data = (0, pako_1.ungzip)(data);
                }
                delete this.packetAccumulators[accumulatorKey];
                this.messagesSubject.next(streem_sdk_protobuf_1.streem.room.DataTrackMessage.decode(new Uint8Array(data)));
            }
        }
        else {
            logger_1.logger.warn(`Incomplete receipt of DataTrackMessage: ${packet.type} messageId: ${accumulator.id} - recieved ${accumulator.latestIndex} packets. Now recieving packet #${packet.index} of messageId ${packet.messageId}.`);
        }
    }
}
exports.DataController = DataController;
//# sourceMappingURL=data_controller.js.map